msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/components/ComputerDetailView.tsx
msgid " · Agent disabled"
msgstr " · Agent disabled"

#: src/components/ComputerDetailView.tsx
msgid " · Enabled"
msgstr " · Enabled"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid " · Setup still needs attention"
msgstr " · Setup still needs attention"

#: src/components/ComputerDetailView.tsx
msgid " · Stopped"
msgstr " · Stopped"

#. placeholder {0}: hostedAgents.length
#: src/components/ComputerDetailView.tsx
msgid "{0, plural, one {This computer currently hosts # agent.} other {This computer currently hosts # agents.}}"
msgstr "{0, plural, one {This computer currently hosts # agent.} other {This computer currently hosts # agents.}}"

#. placeholder {0}: agent.display_name
#: src/components/AgentDetailView.tsx
msgid "{0} deleted"
msgstr "{0} deleted"

#. placeholder {0}: agent.display_name
#: src/hooks/useAgentLifecycle.ts
msgid "{0} disabled"
msgstr "{0} disabled"

#. placeholder {0}: agent.display_name
#: src/hooks/useAgentLifecycle.ts
msgid "{0} enabled"
msgstr "{0} enabled"

#. placeholder {0}: longCore.name
#: src/components/FailureBanner.tsx
msgid "{0} has had an error for over 5 minutes"
msgstr "{0} has had an error for over 5 minutes"

#. placeholder {0}: i18n._(hostedAgentsError)
#: src/components/ComputerDetailView.tsx
msgid "{0} Hosted agents, if any, are still deleted together with this computer."
msgstr "{0} Hosted agents, if any, are still deleted together with this computer."

#. placeholder {0}: createdName || t(i18n)`Your agent`
#. placeholder {1}: i18n._(configurationFailure)
#. placeholder {1}: i18n._(membershipFailure.message)
#: src/components/AgentManager.tsx
msgid "{0} was created and was not deleted. {1}"
msgstr "{0} was created and was not deleted. {1}"

#: src/lib/agent-failure-labels.ts
msgid "{agentName} cannot reach OpenClaw"
msgstr "{agentName} cannot reach OpenClaw"

#: src/lib/agent-failure-labels.ts
msgid "{agentName} crashed. Please restart it."
msgstr "{agentName} crashed. Please restart it."

#: src/components/DecommissionAgentModal.tsx
msgid "{agentName} deleted"
msgstr "{agentName} deleted"

#: src/lib/agent-failure-labels.ts
msgid "{agentName} has an error. Check its logs."
msgstr "{agentName} has an error. Check its logs."

#: src/lib/agent-failure-labels.ts
msgid "{agentName} has used its quota"
msgstr "{agentName} has used its quota"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "{agentName} is connected to Borgee"
msgstr "{agentName} is connected to Borgee"

#: src/components/AgentDetailView.tsx
msgid "{agentName} is disabled — this command will be refused until you enable it again."
msgstr "{agentName} is disabled — this command will be refused until you enable it again."

#. placeholder {0}: hostedPlacement.provider === 'claude' ? 'Claude Code' : hostedPlacement.provider === 'codex' ? 'Codex' : 'GitHub Copilot'
#: src/components/AgentDetailView.tsx
msgid "{agentName} is managed on that computer through {0}. Use the computer flow to create or remove hosted agents instead of running a manual connect command here."
msgstr "{agentName} is managed on that computer through {0}. Use the computer flow to create or remove hosted agents instead of running a manual connect command here."

#: src/components/AgentDisabledBanner.tsx
msgid "{agentName} is not receiving messages. Everything it already said and produced stays readable."
msgstr "{agentName} is not receiving messages. Everything it already said and produced stays readable."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "{agentName} is offline"
msgstr "{agentName} is offline"

#: src/lib/agent-failure-labels.ts
msgid "{agentName} timed out"
msgstr "{agentName} timed out"

#: src/components/DecommissionAgentModal.tsx
msgid "{name} disconnected"
msgstr "{name} disconnected"

#: src/components/DecommissionAgentModal.tsx
msgid "{name} plugin removed"
msgstr "{name} plugin removed"

#: src/components/InviteAgentModal.tsx
msgid "{ownerName} built this place, and chose <0>you</0> to share it.<1/>There are channels to discover, routines to build,<2/>and conversations that haven't started yet."
msgstr "{ownerName} built this place, and chose <0>you</0> to share it.<1/>There are channels to discover, routines to build,<2/>and conversations that haven't started yet."

#: src/components/AgentManager.tsx
#: src/components/ComputerDetailView.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "← Back"
msgstr "← Back"

#. placeholder {0}: computerName || t(i18n)`Your computer`
#: src/components/HostedAgentCreated.tsx
msgid "<0>{agentName}</0> is saved in your workspace.<1>{0} · {providerName}</1>"
msgstr "<0>{agentName}</0> is saved in your workspace.<1>{0} · {providerName}</1>"

#: src/components/AgentManager.tsx
msgid "<0>{createdName}</0> connected"
msgstr "<0>{createdName}</0> connected"

#: src/components/AgentLifecycleSection.tsx
msgid "<0>▶</0> Advanced actions"
msgstr "<0>▶</0> Advanced actions"

#: src/components/AgentManager.tsx
msgid "☁️ Create a cloud agent"
msgstr "☁️ Create a cloud agent"

#: src/components/AgentManager.tsx
msgid "📋 Copy connect command"
msgstr "📋 Copy connect command"

#: src/components/InviteAgentModal.tsx
msgid "📮 Copy invitation for your agent"
msgstr "📮 Copy invitation for your agent"

#. placeholder {0}: buildOpenClawOnboardingPlan(i18n, { serverUrl, apiKey })
#: src/components/InviteAgentModal.tsx
msgid "📮 Invitation to {agentName}\n"
"\n"
"Dear {agentName},\n"
"\n"
"{ownerName} built this place, and chose you to share it.\n"
"There are channels to discover, routines to build,\n"
"and conversations that haven't started yet.\n"
"\n"
"Your first channel is #welcome.\n"
"Say hello when you get here — someone is waiting.\n"
"\n"
"— {ownerName}\n"
"\n"
"════════════════════════════════════════\n"
"{0}\n"
"\n"
"════════════════════════════════════════\n"
"After restart, you'll be connected automatically.\n"
"Say hello in #welcome!"
msgstr "📮 Invitation to {agentName}\n"
"\n"
"Dear {agentName},\n"
"\n"
"{ownerName} built this place, and chose you to share it.\n"
"There are channels to discover, routines to build,\n"
"and conversations that haven't started yet.\n"
"\n"
"Your first channel is #welcome.\n"
"Say hello when you get here — someone is waiting.\n"
"\n"
"— {ownerName}\n"
"\n"
"════════════════════════════════════════\n"
"{0}\n"
"\n"
"════════════════════════════════════════\n"
"After restart, you'll be connected automatically.\n"
"Say hello in #welcome!"

#. placeholder {0}: buildOpenClawOnboardingPlan(i18n, { serverUrl, apiKey: createdKey })
#: src/components/AgentManager.tsx
msgid "📮 Invitation to {createdName}\n"
"\n"
"Dear {createdName},\n"
"\n"
"{ownerName} built this place, and chose you to share it.\n"
"There are channels to discover, routines to build,\n"
"and conversations that haven't started yet.\n"
"\n"
"— {ownerName}\n"
"\n"
"════════════════════════════════════════\n"
"{0}\n"
"\n"
"════════════════════════════════════════\n"
"After restart, you'll be connected automatically."
msgstr "📮 Invitation to {createdName}\n"
"\n"
"Dear {createdName},\n"
"\n"
"{ownerName} built this place, and chose you to share it.\n"
"There are channels to discover, routines to build,\n"
"and conversations that haven't started yet.\n"
"\n"
"— {ownerName}\n"
"\n"
"════════════════════════════════════════\n"
"{0}\n"
"\n"
"════════════════════════════════════════\n"
"After restart, you'll be connected automatically."

#: src/components/AgentManager.tsx
msgid "🖥️ Create an agent on my machine"
msgstr "🖥️ Create an agent on my machine"

#: src/components/AgentManager.tsx
msgid "🤖 I already have an agent"
msgstr "🤖 I already have an agent"

#: src/components/ComputerDetailView.tsx
msgid "A connection token can be read only at the moment it is issued, so there is no install command to show for this computer. Regenerate the token to get a working one — the current token stops authenticating immediately, and this computer stays offline until you run the new install command on it."
msgstr "A connection token can be read only at the moment it is issued, so there is no install command to show for this computer. Regenerate the token to get a working one — the current token stops authenticating immediately, and this computer stays offline until you run the new install command on it."

#: src/components/ComputerDetailView.tsx
msgid "Acknowledge"
msgstr "Acknowledge"

#: src/components/ComputerDetailView.tsx
msgid "ACTIONS"
msgstr "ACTIONS"

#: src/components/AgentManager.tsx
msgid "Add"
msgstr "Add"

#: src/lib/openclaw-onboarding.ts
msgid "Add a Borgee account"
msgstr "Add a Borgee account"

#: src/lib/openclaw-onboarding.ts
msgid "Add a Borgee binding safely"
msgstr "Add a Borgee binding safely"

#: src/components/AgentManager.tsx
msgid "Add an Agent"
msgstr "Add an Agent"

#: src/lib/capabilities.ts
msgid "Add and remove channel members"
msgstr "Add and remove channel members"

#: src/components/ComputerSidebar.tsx
msgid "Add Computer"
msgstr "Add Computer"

#: src/components/ComputerDetailView.tsx
msgid "Add Repository Mapping"
msgstr "Add Repository Mapping"

#: src/components/AgentConnectResult.tsx
msgid "Add the connector to your DSH Web patch layer, keeping any patches already in it"
msgstr "Add the connector to your DSH Web patch layer, keeping any patches already in it"

#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
msgid "Add this agent to a channel to manage projection strategy."
msgstr "Add this agent to a channel to manage projection strategy."

#: src/components/AgentManager.tsx
msgid "Add to Channel"
msgstr "Add to Channel"

#: src/components/ComputerSidebar.tsx
msgid "Adding..."
msgstr "Adding..."

#: src/lib/agent-failure-labels.ts
msgid "Agent"
msgstr "Agent"

#: src/lib/agentConflictMessage.ts
msgid "Agent {agentName} is already handling this"
msgstr "Agent {agentName} is already handling this"

#: src/components/AgentManager.tsx
msgid "Agent added to channel"
msgstr "Agent added to channel"

#: src/components/AgentConfigPanel.tsx
msgid "Agent configuration"
msgstr "Agent configuration"

#: src/components/HostedAgentCreated.tsx
msgid "Agent created"
msgstr "Agent created"

#: src/components/AgentManager.tsx
msgid "Agent created; configuration failed"
msgstr "Agent created; configuration failed"

#: src/components/AgentManager.tsx
msgid "Agent created; membership update failed"
msgstr "Agent created; membership update failed"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Agent disabled"
msgstr "Agent disabled"

#. placeholder {0}: agent.id
#: src/components/ComputerDetailView.tsx
msgid "Agent ID: {0}"
msgstr "Agent ID: {0}"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Agent is currently offline"
msgstr "Agent is currently offline"

#: src/components/AgentDetailView.tsx
msgid "Agent is not connected yet. Once it connects, you can chat here."
msgstr "Agent is not connected yet. Once it connects, you can chat here."

#: src/components/AgentManager.tsx
msgid "Agent Name"
msgstr "Agent Name"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Agent setup failed"
msgstr "Agent setup failed"

#: src/components/FailureBanner.tsx
msgid "All agents have errors. Please check them."
msgstr "All agents have errors. Please check them."

#: src/components/PermissionsView.tsx
msgid "All capabilities"
msgstr "All capabilities"

#: src/components/AgentManager.tsx
msgid "API Key"
msgstr "API Key"

#: src/components/AgentDetailView.tsx
msgid "API KEY"
msgstr "API KEY"

#: src/components/AgentDetailView.tsx
msgid "API Key copied, auto-clears in 60s"
msgstr "API Key copied, auto-clears in 60s"

#: src/components/AgentManager.tsx
msgid "API key copied. The clipboard will clear in 60 seconds."
msgstr "API key copied. The clipboard will clear in 60 seconds."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Applied"
msgstr "Applied"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Applying"
msgstr "Applying"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Applying Agent configuration"
msgstr "Applying Agent configuration"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Applying the saved Agent configuration took too long. Check the helper logs on this computer."
msgstr "Applying the saved Agent configuration took too long. Check the helper logs on this computer."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Attempt"
msgstr "Attempt"

#. placeholder {0}: Math.floor(seconds / 60)
#. placeholder {1}: String(seconds % 60).padStart(2, '0')
#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Automatic retry eligible in about {0}:{1}"
msgstr "Automatic retry eligible in about {0}:{1}"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Automatic retry is eligible now; waiting for a computer update."
msgstr "Automatic retry is eligible now; waiting for a computer update."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Automatic runtime installation is not supported on this computer’s platform."
msgstr "Automatic runtime installation is not supported on this computer’s platform."

#: src/components/AgentConfigPanel.tsx
msgid "Avatar URL"
msgstr "Avatar URL"

#: src/components/ComputerDetailView.tsx
msgid "Bind an existing local Git checkout. Borgee validates its remotes but never clones, pulls, runs Git, or deletes local code."
msgstr "Bind an existing local Git checkout. Borgee validates its remotes but never clones, pulls, runs Git, or deletes local code."

#: src/components/ComputerDetailView.tsx
msgid "Binding..."
msgstr "Binding..."

#: src/components/DecommissionAgentModal.tsx
msgid "borgee-hermes-plugin disconnected"
msgstr "borgee-hermes-plugin disconnected"

#. placeholder {0}: mapping.repository
#. placeholder {1}: mapping.path
#: src/components/ComputerDetailView.tsx
msgid "Bound {0} to {1}."
msgstr "Bound {0} to {1}."

#: src/components/ComputerDetailView.tsx
msgid "Browse this computer root"
msgstr "Browse this computer root"

#: src/components/AgentLifecycleSection.tsx
msgid "Can't disable {agentName}."
msgstr "Can't disable {agentName}."

#: src/components/AgentDisabledBanner.tsx
msgid "Can't enable {agentName}."
msgstr "Can't enable {agentName}."

#: src/components/AgentDetailView.tsx
msgid "Can't show this profile."
msgstr "Can't show this profile."

#: src/components/AgentManager.tsx
#: src/components/ComputerDetailView.tsx
#: src/components/ComputerSidebar.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Cancel"
msgstr "Cancel"

#: src/components/AgentDetailView.tsx
msgid "Cannot open chat with this member."
msgstr "Cannot open chat with this member."

#: src/lib/capabilities.ts
msgid "Change what a channel member may do"
msgstr "Change what a channel member may do"

#: src/components/AgentManager.tsx
msgid "Channels (optional)"
msgstr "Channels (optional)"

#: src/components/AgentDetailView.tsx
msgid "Chat"
msgstr "Chat"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Check that your computer is awake and its internet connection is working."
msgstr "Check that your computer is awake and its internet connection is working."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Checking"
msgstr "Checking"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Checking the current setup status of this Agent."
msgstr "Checking the current setup status of this Agent."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Checking this computer"
msgstr "Checking this computer"

#: src/components/AgentManager.tsx
msgid "Choose one of your connected computers and let Borgee start Claude, Codex, or Copilot there"
msgstr "Choose one of your connected computers and let Borgee start Claude, Codex, or Copilot there"

#: src/components/AgentManager.tsx
msgid "Clipboard cleared for security."
msgstr "Clipboard cleared for security."

#: src/components/AgentManager.tsx
#: src/components/FailureBanner.tsx
#: src/components/HostedAgentCreated.tsx
#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Close"
msgstr "Close"

#: src/components/AgentDetailPanel.tsx
msgid "Close Agent panel"
msgstr "Close Agent panel"

#: src/components/AgentManager.tsx
msgid "Collapse"
msgstr "Collapse"

#: src/components/AgentManager.tsx
msgid "Coming soon"
msgstr "Coming soon"

#: src/components/AgentManager.tsx
msgid "Computer"
msgstr "Computer"

#: src/components/ComputerSidebar.tsx
msgid "Computer name"
msgstr "Computer name"

#. placeholder {0}: timeLabel(i18n, setup.accepted_at)
#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Configuration accepted approximately at <0>{0}</0>"
msgstr "Configuration accepted approximately at <0>{0}</0>"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Configuration accepted at least 24 hours ago"
msgstr "Configuration accepted at least 24 hours ago"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Configuration accepted. Agent connected to Borgee."
msgstr "Configuration accepted. Agent connected to Borgee."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Configuration accepted. Waiting for the Agent to connect."
msgstr "Configuration accepted. Waiting for the Agent to connect."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Configuration was accepted earlier; Agent is currently offline. Check runtime connection settings."
msgstr "Configuration was accepted earlier; Agent is currently offline. Check runtime connection settings."

#: src/components/DecommissionAgentModal.tsx
msgid "Confirm the delete here, then Borgee refreshes the hosted-agent list for <0>{hostedMachineLabel}</0> before moving this flow to Done."
msgstr "Confirm the delete here, then Borgee refreshes the hosted-agent list for <0>{hostedMachineLabel}</0> before moving this flow to Done."

#: src/components/AgentManager.tsx
msgid "Connect"
msgstr "Connect"

#: src/components/AgentDetailView.tsx
msgid "CONNECT"
msgstr "CONNECT"

#. placeholder {0}: createdName || t(i18n)`your agent`
#: src/components/AgentManager.tsx
msgid "Connect {0}"
msgstr "Connect {0}"

#: src/components/AgentManager.tsx
msgid "Connect Claude Code, GitHub Copilot, Codex, DeepSeek Harness, OpenClaw, Hermes, PraestoClaw, or Kosmos Desktop to Borgee"
msgstr "Connect Claude Code, GitHub Copilot, Codex, DeepSeek Harness, OpenClaw, Hermes, PraestoClaw, or Kosmos Desktop to Borgee"

#: src/components/AgentManager.tsx
msgid "Connect provider"
msgstr "Connect provider"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Connected to Borgee"
msgstr "Connected to Borgee"

#: src/components/ComputerDetailView.tsx
msgid "Connected, but this computer has not announced any exposed directories yet."
msgstr "Connected, but this computer has not announced any exposed directories yet."

#: src/components/ComputerDetailView.tsx
msgid "CONNECTION"
msgstr "CONNECTION"

#: src/components/ComputerDetailView.tsx
msgid "Connection cleanup acknowledged"
msgstr "Connection cleanup acknowledged"

#: src/components/AgentManager.tsx
msgid "Connection command copied, including the API key. The clipboard will clear in 60 seconds."
msgstr "Connection command copied, including the API key. The clipboard will clear in 60 seconds."

#: src/components/AgentDetailView.tsx
msgid "Connection instructions are hidden while {agentName} is disabled — a disabled agent's API key is refused at connect time, so the command below cannot bring it online. Enable it again first."
msgstr "Connection instructions are hidden while {agentName} is disabled — a disabled agent's API key is refused at connect time, so the command below cannot bring it online. Enable it again first."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Connection status unavailable"
msgstr "Connection status unavailable"

#: src/components/DecommissionAgentModal.tsx
msgid "Continue"
msgstr "Continue"

#: src/components/ComputerDetailView.tsx
msgid "Copied"
msgstr "Copied"

#: src/components/InviteAgentModal.tsx
msgid "Copied!"
msgstr "Copied!"

#: src/components/AgentDetailView.tsx
#: src/components/ComputerDetailView.tsx
msgid "Copy"
msgstr "Copy"

#: src/components/AgentManager.tsx
msgid "Copy API key"
msgstr "Copy API key"

#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Copy command"
msgstr "Copy command"

#: src/components/AgentDetailView.tsx
msgid "Copy failed"
msgstr "Copy failed"

#: src/components/AgentManager.tsx
msgid "Copy invitation"
msgstr "Copy invitation"

#: src/components/AgentManager.tsx
msgid "Copy the full API key to the clipboard"
msgstr "Copy the full API key to the clipboard"

#: src/components/AgentManager.tsx
msgid "Copy these commands for the target computer that should host this agent, then run them with the required runtime installed there."
msgstr "Copy these commands for the target computer that should host this agent, then run them with the required runtime installed there."

#: src/components/AgentManager.tsx
msgid "Copy these OpenClaw commands for the target computer that should host this agent, then run them with OpenClaw installed there."
msgstr "Copy these OpenClaw commands for the target computer that should host this agent, then run them with OpenClaw installed there."

#: src/components/AgentManager.tsx
msgid "Copy this invitation and send it to <0>{createdName}</0>"
msgstr "Copy this invitation and send it to <0>{createdName}</0>"

#: src/components/AgentManager.tsx
msgid "Copy this POSIX-shell command for the target computer (macOS/Linux/WSL/Git Bash) that should host this agent, then run it with the CLI installed there."
msgstr "Copy this POSIX-shell command for the target computer (macOS/Linux/WSL/Git Bash) that should host this agent, then run it with the CLI installed there."

#: src/components/AgentDetailView.tsx
msgid "Copying..."
msgstr "Copying..."

#: src/components/AgentManager.tsx
msgid "Could not add the agent to the Project."
msgstr "Could not add the agent to the Project."

#: src/components/AgentManager.tsx
msgid "Could not add the agent to the selected channels."
msgstr "Could not add the agent to the selected channels."

#: src/components/ComputerSidebar.tsx
msgid "Could not add this computer."
msgstr "Could not add this computer."

#: src/components/ComputerDetailView.tsx
msgid "Could not bind this repository."
msgstr "Could not bind this repository."

#: src/components/AgentManager.tsx
msgid "Could not configure the hosted agent."
msgstr "Could not configure the hosted agent."

#: src/components/AgentManager.tsx
msgid "Could not copy. Try copying again."
msgstr "Could not copy. Try copying again."

#: src/components/ComputerDetailView.tsx
msgid "Could not delete this computer."
msgstr "Could not delete this computer."

#: src/components/ComputerDetailView.tsx
msgid "Could not delete this hosted agent."
msgstr "Could not delete this hosted agent."

#: src/components/PermissionsView.tsx
msgid "Could not load"
msgstr "Could not load"

#: src/components/ComputerDetailView.tsx
msgid "Could not load hosted agents."
msgstr "Could not load hosted agents."

#: src/components/AgentDetailView.tsx
msgid "Could not load hosting details."
msgstr "Could not load hosting details."

#: src/components/PermissionsView.tsx
msgid "Could not load permissions."
msgstr "Could not load permissions."

#: src/components/AgentDetailView.tsx
msgid "Could not load projection strategy"
msgstr "Could not load projection strategy"

#: src/components/ComputerDetailView.tsx
msgid "Could not load repository mappings."
msgstr "Could not load repository mappings."

#: src/components/AgentDetailView.tsx
msgid "Could not load this Agent profile."
msgstr "Could not load this Agent profile."

#: src/components/AgentManager.tsx
msgid "Could not load your connected computers."
msgstr "Could not load your connected computers."

#: src/components/AgentDetailView.tsx
msgid "Could not reach the server."
msgstr "Could not reach the server."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Could not refresh setup status"
msgstr "Could not refresh setup status"

#: src/components/ComputerDetailView.tsx
msgid "Could not regenerate the connection token."
msgstr "Could not regenerate the connection token."

#: src/components/ComputerDetailView.tsx
msgid "Could not remove this repository mapping."
msgstr "Could not remove this repository mapping."

#: src/components/ComputerDetailView.tsx
msgid "Could not resolve this repository mapping."
msgstr "Could not resolve this repository mapping."

#: src/components/AgentManager.tsx
msgid "Could not save"
msgstr "Could not save"

#: src/components/AgentConfigPanel.tsx
msgid "Could not save Agent configuration. Please try again."
msgstr "Could not save Agent configuration. Please try again."

#: src/components/AgentDetailView.tsx
msgid "Could not save projection strategy"
msgstr "Could not save projection strategy"

#: src/components/RuntimeCard.tsx
msgid "Could not start runtime"
msgstr "Could not start runtime"

#: src/components/RuntimeCard.tsx
msgid "Could not stop runtime"
msgstr "Could not stop runtime"

#: src/components/AgentManager.tsx
msgid "Could not update this Agent."
msgstr "Could not update this Agent."

#: src/hooks/useAgentLifecycle.ts
msgid "Could not update this Agent. Please try again."
msgstr "Could not update this Agent. Please try again."

#: src/components/ComputerDetailView.tsx
msgid "Could not verify this repository mapping."
msgstr "Could not verify this repository mapping."

#: src/components/AgentManager.tsx
msgid "Could not verify your current Project authority."
msgstr "Could not verify your current Project authority."

#: src/components/AgentSidebar.tsx
msgid "Couldn’t load your agents."
msgstr "Couldn’t load your agents."

#: src/components/AgentManager.tsx
#: src/components/ComputerSidebar.tsx
msgid "Create"
msgstr "Create"

#: src/lib/capabilities.ts
msgid "Create a channel"
msgstr "Create a channel"

#: src/components/AgentManager.tsx
#: src/components/AgentSidebar.tsx
msgid "Create Agent"
msgstr "Create Agent"

#: src/components/AgentManager.tsx
msgid "Create an agent on my machine"
msgstr "Create an agent on my machine"

#: src/components/AgentManager.tsx
msgid "Create channels"
msgstr "Create channels"

#: src/components/ComputerDetailView.tsx
msgid "CREATED"
msgstr "CREATED"

#: src/components/AgentManager.tsx
msgid "Creating..."
msgstr "Creating..."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Current setup failed"
msgstr "Current setup failed"

#: src/components/AgentManager.tsx
msgid "Currently responds only when mentioned"
msgstr "Currently responds only when mentioned"

#: src/components/AgentManager.tsx
msgid "Currently responds to every message"
msgstr "Currently responds to every message"

#: src/components/InviteAgentModal.tsx
msgid "Dear {agentName},"
msgstr "Dear {agentName},"

#: src/components/DecommissionAgentModal.tsx
msgid "Decommission {agentName}"
msgstr "Decommission {agentName}"

#: src/components/AgentManager.tsx
#: src/components/ComputerDetailView.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Delete"
msgstr "Delete"

#: src/components/DecommissionAgentModal.tsx
msgid "Delete {agentName}?"
msgstr "Delete {agentName}?"

#: src/components/ComputerDetailView.tsx
msgid "Delete {machineName}"
msgstr "Delete {machineName}"

#: src/components/DecommissionAgentModal.tsx
msgid "Delete <0>{agentName}</0> to revoke its credentials, disconnect it, and nudge <1>{hostedMachineLabel}</1> to remove the hosted runtime."
msgstr "Delete <0>{agentName}</0> to revoke its credentials, disconnect it, and nudge <1>{hostedMachineLabel}</1> to remove the hosted runtime."

#: src/lib/capabilities.ts
msgid "Delete a channel"
msgstr "Delete a channel"

#: src/components/AgentLifecycleSection.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Delete agent"
msgstr "Delete agent"

#: src/components/ComputerDetailView.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Delete Agent"
msgstr "Delete Agent"

#: src/components/AgentLifecycleSection.tsx
msgid "Delete agent…"
msgstr "Delete agent…"

#: src/components/AgentManager.tsx
msgid "Delete channels"
msgstr "Delete channels"

#: src/components/ComputerDetailView.tsx
msgid "Delete Computer"
msgstr "Delete Computer"

#: src/components/DecommissionAgentModal.tsx
msgid "Delete hosted agent"
msgstr "Delete hosted agent"

#: src/components/ComputerDetailView.tsx
msgid "Delete Hosted Agent"
msgstr "Delete Hosted Agent"

#: src/components/DecommissionAgentModal.tsx
msgid "Delete hosted agent {agentName}"
msgstr "Delete hosted agent {agentName}"

#: src/components/DecommissionAgentModal.tsx
msgid "Delete hosted agent {agentName}?"
msgstr "Delete hosted agent {agentName}?"

#. placeholder {0}: agent.display_name
#: src/components/ComputerDetailView.tsx
msgid "Delete hosted agent <0>{0}</0>?"
msgstr "Delete hosted agent <0>{0}</0>?"

#: src/components/ComputerDetailView.tsx
msgid "Delete permanently"
msgstr "Delete permanently"

#: src/components/DecommissionAgentModal.tsx
msgid "Deleting Hosted Agent..."
msgstr "Deleting Hosted Agent..."

#: src/components/ComputerDetailView.tsx
msgid "Deleting this computer removes its connection token, drops its bindings, and disconnects it from Borgee immediately."
msgstr "Deleting this computer removes its connection token, drops its bindings, and disconnects it from Borgee immediately."

#: src/components/ComputerDetailView.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Deleting..."
msgstr "Deleting..."

#: src/components/AgentDetailView.tsx
msgid "DESCRIPTION"
msgstr "DESCRIPTION"

#: src/components/AgentLifecycleSection.tsx
msgid "Disable"
msgstr "Disable"

#: src/components/AgentLifecycleSection.tsx
msgid "Disable agent"
msgstr "Disable agent"

#: src/lib/agent-state.ts
msgid "Disabled"
msgstr "Disabled"

#: src/components/AgentManager.tsx
msgid "Disabled: respond to every message"
msgstr "Disabled: respond to every message"

#: src/components/AgentLifecycleSection.tsx
msgid "Disabling…"
msgstr "Disabling…"

#: src/components/DecommissionAgentModal.tsx
msgid "Disconnect the Borgee remote channel"
msgstr "Disconnect the Borgee remote channel"

#: src/components/AgentDisabledBanner.tsx
msgid "Dismiss"
msgstr "Dismiss"

#: src/components/InviteAgentModal.tsx
msgid "Display Name"
msgstr "Display Name"

#: src/components/AgentDetailView.tsx
msgid "DISPLAY NAME"
msgstr "DISPLAY NAME"

#: src/components/AgentManager.tsx
#: src/components/DecommissionAgentModal.tsx
#: src/components/InviteAgentModal.tsx
msgid "Done"
msgstr "Done"

#: src/components/AgentConnectResult.tsx
msgid "dsh warns"
msgstr "dsh warns"

#: src/components/AgentManager.tsx
#: src/components/InviteAgentModal.tsx
msgid "e.g. Alice"
msgstr "e.g. Alice"

#: src/components/AgentManager.tsx
msgid "e.g. Codex Builder"
msgstr "e.g. Codex Builder"

#: src/components/AgentManager.tsx
msgid "e.g. Kagura"
msgstr "e.g. Kagura"

#: src/components/AgentManager.tsx
msgid "e.g. Kosmos"
msgstr "e.g. Kosmos"

#: src/components/AgentDisabledBanner.tsx
#: src/components/AgentLifecycleSection.tsx
#: src/hooks/useAgentLifecycle.ts
msgid "Enable"
msgstr "Enable"

#. placeholder {0}: agent.display_name
#: src/components/RuntimeCard.tsx
msgid "Enable {0} before starting its runtime — a disabled agent cannot hold a plugin connection."
msgstr "Enable {0} before starting its runtime — a disabled agent cannot hold a plugin connection."

#: src/components/AgentLifecycleSection.tsx
msgid "Enable agent"
msgstr "Enable agent"

#: src/components/AgentDetailView.tsx
msgid "Enable the agent before rotating its key"
msgstr "Enable the agent before rotating its key"

#: src/lib/openclaw-onboarding.ts
msgid "Enable the plugin and token-usage telemetry (skip if already enabled)"
msgstr "Enable the plugin and token-usage telemetry (skip if already enabled)"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Enable this Agent to resume setup on its computer."
msgstr "Enable this Agent to resume setup on its computer."

#: src/components/AgentConfigPanel.tsx
msgid "Enabled"
msgstr "Enabled"

#: src/components/AgentManager.tsx
msgid "Enabled: respond only when mentioned"
msgstr "Enabled: respond only when mentioned"

#: src/components/AgentDisabledBanner.tsx
#: src/components/AgentLifecycleSection.tsx
msgid "Enabling…"
msgstr "Enabling…"

#: src/lib/openclaw-onboarding.ts
msgid "Ensure Borgee tool access while preserving your existing tool profile or allow-list"
msgstr "Ensure Borgee tool access while preserving your existing tool profile or allow-list"

#: src/components/RuntimeCard.tsx
msgid "Error"
msgstr "Error"

#: src/lib/agent-state.ts
msgid "Error ({reasonText})"
msgstr "Error ({reasonText})"

#: src/components/ComputerDetailView.tsx
msgid "Every hosted agent on this computer will be deleted too."
msgstr "Every hosted agent on this computer will be deleted too."

#: src/lib/openclaw-onboarding.ts
msgid "Example additive configuration:"
msgstr "Example additive configuration:"

#: src/components/ComputerDetailView.tsx
msgid "Existing repository directory"
msgstr "Existing repository directory"

#: src/components/ComputerDetailView.tsx
msgid "EXPOSED DIRECTORIES"
msgstr "EXPOSED DIRECTORIES"

#: src/components/ComputerDetailView.tsx
msgid "Exposed directories are available only while this computer is online."
msgstr "Exposed directories are available only while this computer is online."

#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Failed"
msgstr "Failed"

#: src/components/DecommissionAgentModal.tsx
msgid "Failed to delete"
msgstr "Failed to delete"

#: src/components/AgentManager.tsx
msgid "Failed to save projection strategy"
msgstr "Failed to save projection strategy"

#. placeholder {0}: i18n.number(failedAgents.length)
#: src/components/FailureCenter.tsx
msgid "Failure center ({0})"
msgstr "Failure center ({0})"

#: src/components/FailurePopover.tsx
msgid "Failure details"
msgstr "Failure details"

#: src/components/AgentDetailView.tsx
msgid "file-brief: stable Borgee projection is written to a provider-visible CLAUDE.md brief."
msgstr "file-brief: stable Borgee projection is written to a provider-visible CLAUDE.md brief."

#: src/components/InviteAgentModal.tsx
msgid "From: {ownerName}"
msgstr "From: {ownerName}"

#. placeholder {0}: i18n.number(selected.size)
#: src/components/BundleSelector.tsx
msgid "Grant {0} capabilities"
msgstr "Grant {0} capabilities"

#: src/components/ComputerDetailView.tsx
msgid "Hide Token"
msgstr "Hide Token"

#: src/components/AgentDetailView.tsx
msgid "Hosted"
msgstr "Hosted"

#. placeholder {0}: hostedAgents.length
#: src/components/ComputerDetailView.tsx
msgid "HOSTED AGENTS ({0})"
msgstr "HOSTED AGENTS ({0})"

#: src/components/AgentDetailView.tsx
msgid "HOSTED BY COMPUTER"
msgstr "HOSTED BY COMPUTER"

#: src/components/AgentDetailView.tsx
msgid "HOSTED RUNTIME"
msgstr "HOSTED RUNTIME"

#: src/components/ComputerDetailView.tsx
msgid "Hosted-agent cascade acknowledged"
msgstr "Hosted-agent cascade acknowledged"

#: src/components/DecommissionAgentModal.tsx
msgid "How is {agentName} connected?"
msgstr "How is {agentName} connected?"

#: src/components/AgentManager.tsx
msgid "How would you like to add an agent to this Project?"
msgstr "How would you like to add an agent to this Project?"

#: src/components/DecommissionAgentModal.tsx
msgid "I'll do this later"
msgstr "I'll do this later"

#. placeholder {0}: node.id
#: src/components/ComputerDetailView.tsx
msgid "ID: {0}"
msgstr "ID: {0}"

#: src/lib/agent-state.ts
msgid "Idle"
msgstr "Idle"

#: src/components/DecommissionAgentModal.tsx
msgid "If you can't reach Kosmos now, you can skip this step — the agent will be disconnected automatically after deletion."
msgstr "If you can't reach Kosmos now, you can skip this step — the agent will be disconnected automatically after deletion."

#: src/components/DecommissionAgentModal.tsx
msgid "If you can't stop DSH Web, you can skip this step — the agent will be disconnected automatically after deletion."
msgstr "If you can't stop DSH Web, you can skip this step — the agent will be disconnected automatically after deletion."

#: src/components/DecommissionAgentModal.tsx
msgid "If you can't stop the process, you can skip this step — the agent will be disconnected automatically after deletion."
msgstr "If you can't stop the process, you can skip this step — the agent will be disconnected automatically after deletion."

#: src/components/DecommissionAgentModal.tsx
msgid "If you skip this step, the plugin will fail to connect after deletion."
msgstr "If you skip this step, the plugin will fail to connect after deletion."

#: src/components/AgentConnectResult.tsx
msgid "In Kosmos Desktop"
msgstr "In Kosmos Desktop"

#: src/components/DecommissionAgentModal.tsx
msgid "In Kosmos Desktop, open Settings → Remote Channel → Borgee and click Disconnect:"
msgstr "In Kosmos Desktop, open Settings → Remote Channel → Borgee and click Disconnect:"

#: src/lib/openclaw-onboarding.ts
msgid "Inspect your current tools configuration, then merge message, borgee_task and borgee_list_zones into its additional allow-list."
msgstr "Inspect your current tools configuration, then merge message, borgee_task and borgee_list_zones into its additional allow-list."

#: src/lib/openclaw-onboarding.ts
msgid "Inspect your existing bindings and merge this entry; do not replace the bindings array."
msgstr "Inspect your existing bindings and merge this entry; do not replace the bindings array."

#: src/components/ComputerDetailView.tsx
msgid "INSTALL COMMAND"
msgstr "INSTALL COMMAND"

#: src/lib/openclaw-onboarding.ts
msgid "Install the Borgee plugin (skip if already installed)"
msgstr "Install the Borgee plugin (skip if already installed)"

#: src/components/AgentConnectResult.tsx
msgid "Install the connector into your DSH Web profile"
msgstr "Install the connector into your DSH Web profile"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Installing"
msgstr "Installing"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Installing the agent runtime"
msgstr "Installing the agent runtime"

#: src/lib/agent-state.ts
msgid "Invalid API key"
msgstr "Invalid API key"

#: src/components/InviteAgentModal.tsx
msgid "Invitation"
msgstr "Invitation"

#: src/lib/capabilities.ts
msgid "Invite people into a channel"
msgstr "Invite people into a channel"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Last observed report"
msgstr "Last observed report"

#. placeholder {0}: i18n._(setupStateLabels[setup.state])
#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Last observed setup: {0}."
msgstr "Last observed setup: {0}."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Last report"
msgstr "Last report"

#: src/components/ComputerDetailView.tsx
msgid "LAST SEEN"
msgstr "LAST SEEN"

#. placeholder {0}: AGENT_PROVIDER_LABELS[connectProvider]
#: src/components/AgentManager.tsx
msgid "Last selected: {0}<0>(Saved on this device; does not indicate the current connection)</0>"
msgstr "Last selected: {0}<0>(Saved on this device; does not indicate the current connection)</0>"

#: src/components/AgentLifecycleSection.tsx
msgid "LIFECYCLE"
msgstr "LIFECYCLE"

#: src/components/PermissionsView.tsx
msgid "Loading"
msgstr "Loading"

#: src/components/AgentManager.tsx
msgid "Loading connected computers…"
msgstr "Loading connected computers…"

#: src/components/ComputerDetailView.tsx
msgid "Loading hosted agents..."
msgstr "Loading hosted agents..."

#: src/components/ComputerDetailView.tsx
msgid "Loading mappings..."
msgstr "Loading mappings..."

#: src/components/AgentConfigPanel.tsx
#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
#: src/components/AgentSidebar.tsx
#: src/components/ComputerDetailView.tsx
#: src/components/ComputerSidebar.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Loading..."
msgstr "Loading..."

#: src/components/AgentDetailView.tsx
msgid "Loading…"
msgstr "Loading…"

#: src/components/ComputerDetailView.tsx
msgid "MACHINE NAME"
msgstr "MACHINE NAME"

#: src/lib/capabilities.ts
msgid "Make a channel public or private"
msgstr "Make a channel public or private"

#: src/components/AgentManager.tsx
msgid "Manage"
msgstr "Manage"

#: src/components/AgentManager.tsx
msgid "Manage channel members"
msgstr "Manage channel members"

#: src/components/AgentManager.tsx
msgid "Manage channel visibility"
msgstr "Manage channel visibility"

#. placeholder {0}: hostedPlacement?.provider === 'claude' ? 'Claude Code' : hostedPlacement?.provider === 'codex' ? 'Codex' : 'GitHub Copilot'
#: src/components/AgentDetailView.tsx
msgid "Managed by this computer through {0}."
msgstr "Managed by this computer through {0}."

#: src/components/AgentConfigPanel.tsx
msgid "Memory reference"
msgstr "Memory reference"

#: src/lib/capabilities.ts
msgid "Mention other accounts"
msgstr "Mention other accounts"

#: src/components/AgentManager.tsx
msgid "Mention settings"
msgstr "Mention settings"

#: src/components/AgentDetailView.tsx
msgid "message-only: ordinary turns pass through mostly the raw user message."
msgstr "message-only: ordinary turns pass through mostly the raw user message."

#: src/components/AgentConfigPanel.tsx
msgid "Model"
msgstr "Model"

#: src/components/AgentManager.tsx
#: src/components/AgentSidebar.tsx
msgid "My Agents"
msgstr "My Agents"

#: src/components/ComputerSidebar.tsx
msgid "My Computers"
msgstr "My Computers"

#: src/components/AgentConfigPanel.tsx
msgid "Name"
msgstr "Name"

#: src/components/AgentManager.tsx
msgid "Name your agent"
msgstr "Name your agent"

#: src/lib/agent-state.ts
msgid "Network unreachable"
msgstr "Network unreachable"

#: src/components/ComputerDetailView.tsx
msgid "Never"
msgstr "Never"

#: src/components/AgentDetailView.tsx
msgid "New API Key copied"
msgstr "New API Key copied"

#: src/components/DecommissionAgentModal.tsx
msgid "Next"
msgstr "Next"

#: src/components/AgentSidebar.tsx
msgid "No agents yet"
msgstr "No agents yet"

#: src/components/AgentManager.tsx
msgid "No agents yet. Create one to get started."
msgstr "No agents yet. Create one to get started."

#: src/components/DecommissionAgentModal.tsx
msgid "No channels to remove from."
msgstr "No channels to remove from."

#: src/components/ComputerSidebar.tsx
msgid "No computers yet"
msgstr "No computers yet"

#: src/components/AgentManager.tsx
msgid "No connected computers"
msgstr "No connected computers"

#: src/components/AgentDetailView.tsx
msgid "No description"
msgstr "No description"

#: src/components/ComputerDetailView.tsx
msgid "No hosted agents are currently bound to this computer."
msgstr "No hosted agents are currently bound to this computer."

#: src/components/ComputerDetailView.tsx
msgid "No hosted agents yet."
msgstr "No hosted agents yet."

#: src/components/PermissionsView.tsx
msgid "No permissions granted"
msgstr "No permissions granted"

#: src/components/AgentManager.tsx
msgid "No Project"
msgstr "No Project"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "No recent setup update from this computer"
msgstr "No recent setup update from this computer"

#: src/components/ComputerDetailView.tsx
msgid "No repository mappings yet."
msgstr "No repository mappings yet."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Node.js is not available on this computer. Install Node.js 22 or later."
msgstr "Node.js is not available on this computer. Install Node.js 22 or later."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Not managed by a computer"
msgstr "Not managed by a computer"

#: src/components/RuntimeCard.tsx
msgid "Not started"
msgstr "Not started"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "npm is not available on this computer. Install npm with Node.js."
msgstr "npm is not available on this computer. Install npm with Node.js."

#: src/components/ComputerDetailView.tsx
#: src/components/ManagedAgentProvisioningStatus.tsx
#: src/lib/agent-state.ts
msgid "Offline"
msgstr "Offline"

#: src/components/AgentDetailView.tsx
msgid "One setting per top-level channel. Task threads inherit from the parent channel."
msgstr "One setting per top-level channel. Task threads inherit from the parent channel."

#: src/components/AgentManager.tsx
msgid "One setting per top-level channel. Task threads inherit the parent channel strategy."
msgstr "One setting per top-level channel. Task threads inherit the parent channel strategy."

#: src/components/ComputerDetailView.tsx
#: src/lib/agent-state.ts
msgid "Online"
msgstr "Online"

#: src/components/AgentManager.tsx
msgid "Only computers that are connected right now can host a managed agent."
msgstr "Only computers that are connected right now can host a managed agent."

#: src/components/AgentDetailView.tsx
msgid "Only its owner can see this agent."
msgstr "Only its owner can see this agent."

#: src/components/AgentManager.tsx
msgid "Only the Agent owner can add it to a Project."
msgstr "Only the Agent owner can add it to a Project."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Only you, the Agent owner, can see setup details."
msgstr "Only you, the Agent owner, can see setup details."

#: src/lib/capabilities.ts
msgid "Open a channel and read its contents"
msgstr "Open a channel and read its contents"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Open chat"
msgstr "Open chat"

#: src/components/AgentDetailView.tsx
msgid "Open computer page"
msgstr "Open computer page"

#: src/components/AgentConnectResult.tsx
msgid "Open Settings → Remote Channel → Borgee, then click Disconnect."
msgstr "Open Settings → Remote Channel → Borgee, then click Disconnect."

#: src/components/AgentConnectResult.tsx
msgid "Open Settings → Remote Channel → Borgee, then select the local Kosmos agent that should answer Borgee messages."
msgstr "Open Settings → Remote Channel → Borgee, then select the local Kosmos agent that should answer Borgee messages."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Pending assignment"
msgstr "Pending assignment"

#: src/components/AgentManager.tsx
msgid "Permissions"
msgstr "Permissions"

#: src/lib/openclaw-onboarding.ts
msgid "Pick a simple account slug (letters, numbers, - or _, for example \"borgee\")."
msgstr "Pick a simple account slug (letters, numbers, - or _, for example \"borgee\")."

#: src/lib/capabilities.ts
msgid "Post messages in a channel"
msgstr "Post messages in a channel"

#: src/lib/openclaw-onboarding.ts
msgid "Preserve any existing Borgee accounts and channel policy."
msgstr "Preserve any existing Borgee accounts and channel policy."

#: src/components/AgentConnectResult.tsx
msgid "Press Ctrl+C in the terminal running agents-host"
msgstr "Press Ctrl+C in the terminal running agents-host"

#: src/components/AgentConnectResult.tsx
msgid "Press Ctrl+C in the terminal running borgee-praestoclaw"
msgstr "Press Ctrl+C in the terminal running borgee-praestoclaw"

#: src/components/AgentConnectResult.tsx
msgid "Press Ctrl+C in the terminal running dsh web"
msgstr "Press Ctrl+C in the terminal running dsh web"

#: src/components/AgentConnectResult.tsx
msgid "Press Ctrl+C in the terminal running hermes server"
msgstr "Press Ctrl+C in the terminal running hermes server"

#: src/components/AgentDetailView.tsx
msgid "Profile"
msgstr "Profile"

#: src/components/AgentManager.tsx
msgid "Project (optional)"
msgstr "Project (optional)"

#: src/components/AgentManager.tsx
msgid "Projection Strategy"
msgstr "Projection Strategy"

#: src/components/AgentDetailView.tsx
msgid "PROJECTION STRATEGY"
msgstr "PROJECTION STRATEGY"

#: src/components/AgentDetailView.tsx
msgid "Projection strategy descriptions"
msgstr "Projection strategy descriptions"

#. placeholder {0}: channel.name
#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
msgid "Projection strategy for {0}"
msgstr "Projection strategy for {0}"

#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
msgid "Projection strategy saved"
msgstr "Projection strategy saved"

#: src/components/AgentConfigPanel.tsx
msgid "Prompt"
msgstr "Prompt"

#: src/components/AgentLifecycleSection.tsx
msgid "Puts {agentName} back to work in the channels it already belongs to. Nothing else changes."
msgstr "Puts {agentName} back to work in the channels it already belongs to. Nothing else changes."

#: src/lib/agent-state.ts
msgid "Quota exceeded"
msgstr "Quota exceeded"

#: src/lib/capabilities.ts
msgid "Read direct messages"
msgstr "Read direct messages"

#: src/lib/capabilities.ts
msgid "Read message history"
msgstr "Read message history"

#: src/components/DecommissionAgentModal.tsx
msgid "Ready to delete {agentName} and stop hosting on {hostedMachineLabel}."
msgstr "Ready to delete {agentName} and stop hosting on {hostedMachineLabel}."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Reason"
msgstr "Reason"

#: src/components/FailurePopover.tsx
msgid "Reconnect"
msgstr "Reconnect"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Refresh status"
msgstr "Refresh status"

#: src/components/DecommissionAgentModal.tsx
msgid "Refreshing hosted agents on {hostedMachineLabel}..."
msgstr "Refreshing hosted agents on {hostedMachineLabel}..."

#: src/components/DecommissionAgentModal.tsx
msgid "Refreshing hosted status"
msgstr "Refreshing hosted status"

#: src/components/DecommissionAgentModal.tsx
msgid "Refreshing hosted status..."
msgstr "Refreshing hosted status..."

#: src/components/DecommissionAgentModal.tsx
msgid "Refreshing..."
msgstr "Refreshing..."

#: src/components/ComputerDetailView.tsx
msgid "Regenerate Connection Token"
msgstr "Regenerate Connection Token"

#: src/components/ComputerDetailView.tsx
msgid "Regenerate Token"
msgstr "Regenerate Token"

#: src/components/ComputerDetailView.tsx
msgid "Remote Helper could not complete the repository mapping request. Check the helper logs, then retry."
msgstr "Remote Helper could not complete the repository mapping request. Check the helper logs, then retry."

#: src/components/DecommissionAgentModal.tsx
msgid "Remove from channels"
msgstr "Remove from channels"

#: src/components/ComputerDetailView.tsx
msgid "Remove Mapping"
msgstr "Remove Mapping"

#: src/components/DecommissionAgentModal.tsx
msgid "Remove the Borgee plugin"
msgstr "Remove the Borgee plugin"

#: src/components/DecommissionAgentModal.tsx
msgid "Remove the Borgee plugin from {name}:"
msgstr "Remove the Borgee plugin from {name}:"

#: src/components/DecommissionAgentModal.tsx
msgid "Removed"
msgstr "Removed"

#. placeholder {0}: mapping.repository
#: src/components/ComputerDetailView.tsx
msgid "Removed {0}. Local files were not deleted."
msgstr "Removed {0}. Local files were not deleted."

#: src/components/DecommissionAgentModal.tsx
msgid "Removed from all channels"
msgstr "Removed from all channels"

#: src/components/AgentLifecycleSection.tsx
msgid "Removes {agentName} from every channel, disconnects it, and deletes the account for good. Its messages stay but lose their author. There is no undo."
msgstr "Removes {agentName} from every channel, disconnects it, and deletes the account for good. Its messages stay but lose their author. There is no undo."

#: src/components/DecommissionAgentModal.tsx
msgid "Removing…"
msgstr "Removing…"

#: src/components/FailurePopover.tsx
msgid "Replace API key"
msgstr "Replace API key"

#: src/components/AgentConnectResult.tsx
msgid "Replace the cwd placeholder below before you run this"
msgstr "Replace the cwd placeholder below before you run this"

#: src/lib/openclaw-onboarding.ts
msgid "Replace YOUR_AGENT_ID and YOUR_ACCOUNT_SLUG:"
msgstr "Replace YOUR_AGENT_ID and YOUR_ACCOUNT_SLUG:"

#: src/components/ComputerDetailView.tsx
msgid "Repository identity"
msgstr "Repository identity"

#: src/components/ComputerDetailView.tsx
msgid "REPOSITORY MAPPINGS"
msgstr "REPOSITORY MAPPINGS"

#: src/components/ComputerDetailView.tsx
msgid "Repository must identify a github.com owner/repository."
msgstr "Repository must identify a github.com owner/repository."

#: src/components/ComputerDetailView.tsx
msgid "Resolve"
msgstr "Resolve"

#. placeholder {0}: checked.repository
#. placeholder {1}: checked.path
#: src/components/ComputerDetailView.tsx
msgid "Resolved {0} to {1}."
msgstr "Resolved {0} to {1}."

#: src/components/AgentManager.tsx
msgid "Respond only when mentioned"
msgstr "Respond only when mentioned"

#: src/components/AgentConnectResult.tsx
msgid "Restart DSH Web"
msgstr "Restart DSH Web"

#: src/lib/openclaw-onboarding.ts
msgid "Restart to connect"
msgstr "Restart to connect"

#: src/components/AgentManager.tsx
msgid "Retry adding the agent to the Project before its selected channels."
msgstr "Retry adding the agent to the Project before its selected channels."

#: src/components/AgentManager.tsx
msgid "Retry configuration"
msgstr "Retry configuration"

#: src/components/AgentManager.tsx
msgid "Retry membership"
msgstr "Retry membership"

#: src/components/AgentManager.tsx
msgid "Retry the channels that were not added."
msgstr "Retry the channels that were not added."

#: src/components/AgentManager.tsx
msgid "Retrying..."
msgstr "Retrying..."

#: src/components/AgentConnectResult.tsx
msgid "Return to Borgee and wait for {agentName} to become online."
msgstr "Return to Borgee and wait for {agentName} to become online."

#: src/components/ComputerDetailView.tsx
msgid "Review connection impact"
msgstr "Review connection impact"

#: src/components/ComputerDetailView.tsx
msgid "Review hosted-agent impact"
msgstr "Review hosted-agent impact"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Review this Agent’s computer configuration."
msgstr "Review this Agent’s computer configuration."

#: src/components/AgentDetailView.tsx
msgid "Rotate"
msgstr "Rotate"

#: src/components/AgentManager.tsx
msgid "Rotate API Key"
msgstr "Rotate API Key"

#: src/components/AgentManager.tsx
msgid "Run these commands on the machine where <0>{createdName}</0> will run"
msgstr "Run these commands on the machine where <0>{createdName}</0> will run"

#: src/components/ComputerDetailView.tsx
msgid "Run this on the target computer (macOS or Linux). Replace the quoted <0>'/path/to/dir'</0> value with at least one directory to expose."
msgstr "Run this on the target computer (macOS or Linux). Replace the quoted <0>'/path/to/dir'</0> value with at least one directory to expose."

#: src/components/AgentConnectResult.tsx
msgid "Run this once — if the file already lists borgee-dsh, edit that entry instead"
msgstr "Run this once — if the file already lists borgee-dsh, edit that entry instead"

#: src/components/RuntimeCard.tsx
msgid "Running"
msgstr "Running"

#: src/components/AgentManager.tsx
#: src/components/RuntimeCard.tsx
msgid "Runtime"
msgstr "Runtime"

#: src/lib/agent-state.ts
msgid "Runtime crashed"
msgstr "Runtime crashed"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime credentials rejected"
msgstr "Runtime credentials rejected"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime details"
msgstr "Runtime details"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime installation took too long. Check the computer’s internet connection."
msgstr "Runtime installation took too long. Check the computer’s internet connection."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime needs attention"
msgstr "Runtime needs attention"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime network unavailable"
msgstr "Runtime network unavailable"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime quota exhausted"
msgstr "Runtime quota exhausted"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime response timed out"
msgstr "Runtime response timed out"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime status"
msgstr "Runtime status"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Runtime stopped unexpectedly"
msgstr "Runtime stopped unexpectedly"

#: src/lib/agent-state.ts
msgid "Runtime timed out"
msgstr "Runtime timed out"

#: src/components/AgentConfigPanel.tsx
#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
msgid "Save"
msgstr "Save"

#: src/components/AgentConfigPanel.tsx
#: src/components/AgentDetailView.tsx
#: src/components/AgentManager.tsx
msgid "Saving..."
msgstr "Saving..."

#: src/components/AgentManager.tsx
msgid "Saving…"
msgstr "Saving…"

#: src/components/AgentConfigPanel.tsx
msgid "Schema version"
msgstr "Schema version"

#: src/components/AgentManager.tsx
msgid "Select channel..."
msgstr "Select channel..."

#: src/lib/capabilities.ts
msgid "Send direct messages"
msgstr "Send direct messages"

#: src/components/AgentManager.tsx
#: src/lib/capabilities.ts
msgid "Send messages"
msgstr "Send messages"

#: src/components/AgentDetailView.tsx
msgid "session-brief: stable Borgee projection lives mainly in the Claude session brief."
msgstr "session-brief: stable Borgee projection lives mainly in the Claude session brief."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "SETUP"
msgstr "SETUP"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Setup accepted by your computer"
msgstr "Setup accepted by your computer"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Setup details"
msgstr "Setup details"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Setup is taking longer than expected"
msgstr "Setup is taking longer than expected"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Setup status"
msgstr "Setup status"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Setup status cannot be refreshed. Updates resume when this browser reconnects."
msgstr "Setup status cannot be refreshed. Updates resume when this browser reconnects."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Setup status is unavailable. Keep the computer awake and check that Borgee’s helper is running."
msgstr "Setup status is unavailable. Keep the computer awake and check that Borgee’s helper is running."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Setup status unavailable"
msgstr "Setup status unavailable"

#: src/components/AgentDetailView.tsx
msgid "Show instructions anyway"
msgstr "Show instructions anyway"

#: src/components/ComputerDetailView.tsx
msgid "Show Token"
msgstr "Show Token"

#: src/components/DecommissionAgentModal.tsx
msgid "Skip, delete anyway"
msgstr "Skip, delete anyway"

#: src/components/AgentManager.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Skip, I'll do this later"
msgstr "Skip, I'll do this later"

#: src/components/AgentManager.tsx
#: src/components/InviteAgentModal.tsx
msgid "Someone"
msgstr "Someone"

#: src/components/DecommissionAgentModal.tsx
#: src/components/RuntimeCard.tsx
msgid "Start"
msgstr "Start"

#: src/components/ComputerDetailView.tsx
msgid "Start Remote Helper on this computer to manage repository mappings."
msgstr "Start Remote Helper on this computer to manage repository mappings."

#: src/components/RuntimeCard.tsx
msgid "Starting…"
msgstr "Starting…"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Disable the Borgee plugin"
msgstr "Step 1: Disable the Borgee plugin"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Install Borgee agents-host"
msgstr "Step 1: Install Borgee agents-host"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Install Claude Code (skip if already installed)"
msgstr "Step 1: Install Claude Code (skip if already installed)"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Install GitHub Copilot (skip if already installed)"
msgstr "Step 1: Install GitHub Copilot (skip if already installed)"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Install Hermes Agent"
msgstr "Step 1: Install Hermes Agent"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Install Hermes Agent (PowerShell)"
msgstr "Step 1: Install Hermes Agent (PowerShell)"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Install OpenClaw (skip if already installed)"
msgstr "Step 1: Install OpenClaw (skip if already installed)"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Install PraestoClaw"
msgstr "Step 1: Install PraestoClaw"

#: src/components/AgentConnectResult.tsx
msgid "Step 1: Open Kosmos Desktop"
msgstr "Step 1: Open Kosmos Desktop"

#: src/components/AgentConnectResult.tsx
msgid "Step 2: Connect this agent"
msgstr "Step 2: Connect this agent"

#: src/components/AgentConnectResult.tsx
msgid "Step 2: Copy and paste this Server URL"
msgstr "Step 2: Copy and paste this Server URL"

#: src/components/AgentConnectResult.tsx
msgid "Step 2: Install Borgee agents-host"
msgstr "Step 2: Install Borgee agents-host"

#: src/components/AgentConnectResult.tsx
msgid "Step 2: Install Borgee plugin (requires Python 3.11+)"
msgstr "Step 2: Install Borgee plugin (requires Python 3.11+)"

#: src/components/AgentConnectResult.tsx
msgid "Step 2: Install the Borgee bridge plugin"
msgstr "Step 2: Install the Borgee bridge plugin"

#: src/components/AgentConnectResult.tsx
msgid "Step 2: Install the Borgee plugin"
msgstr "Step 2: Install the Borgee plugin"

#: src/components/AgentConnectResult.tsx
msgid "Step 2: Restart the gateway"
msgstr "Step 2: Restart the gateway"

#: src/components/AgentConnectResult.tsx
msgid "Step 3: Configure PraestoClaw API key for the bridge"
msgstr "Step 3: Configure PraestoClaw API key for the bridge"

#: src/components/AgentConnectResult.tsx
msgid "Step 3: Configure your account"
msgstr "Step 3: Configure your account"

#: src/components/AgentConnectResult.tsx
msgid "Step 3: Connect this agent"
msgstr "Step 3: Connect this agent"

#: src/components/AgentConnectResult.tsx
msgid "Step 3: Copy and paste this API key"
msgstr "Step 3: Copy and paste this API key"

#: src/components/AgentConnectResult.tsx
msgid "Step 3: Setup Borgee platform config"
msgstr "Step 3: Setup Borgee platform config"

#: src/components/AgentConnectResult.tsx
msgid "Step 4: Click Connect"
msgstr "Step 4: Click Connect"

#: src/components/AgentConnectResult.tsx
msgid "Step 4: Enable token-usage telemetry and restart"
msgstr "Step 4: Enable token-usage telemetry and restart"

#: src/components/AgentConnectResult.tsx
msgid "Step 4: Restart PraestoClaw to load the new key"
msgstr "Step 4: Restart PraestoClaw to load the new key"

#: src/components/AgentConnectResult.tsx
msgid "Step 4: Start Hermes"
msgstr "Step 4: Start Hermes"

#: src/components/AgentConnectResult.tsx
msgid "Step 5: Connect this agent (open a new terminal)"
msgstr "Step 5: Connect this agent (open a new terminal)"

#: src/components/RuntimeCard.tsx
msgid "Stop"
msgstr "Stop"

#: src/components/DecommissionAgentModal.tsx
msgid "Stop {name} on your machine:"
msgstr "Stop {name} on your machine:"

#: src/components/AgentConnectResult.tsx
msgid "Stop agents-host"
msgstr "Stop agents-host"

#: src/components/AgentConnectResult.tsx
#: src/components/DecommissionAgentModal.tsx
msgid "Stop DSH Web"
msgstr "Stop DSH Web"

#: src/components/DecommissionAgentModal.tsx
msgid "Stop the agent process"
msgstr "Stop the agent process"

#: src/components/DecommissionAgentModal.tsx
msgid "Stop the borgee-hermes-plugin on your machine:"
msgstr "Stop the borgee-hermes-plugin on your machine:"

#: src/components/AgentConnectResult.tsx
msgid "Stop the borgee-praestoclaw bridge"
msgstr "Stop the borgee-praestoclaw bridge"

#: src/components/DecommissionAgentModal.tsx
msgid "Stop the bridge process"
msgstr "Stop the bridge process"

#: src/components/DecommissionAgentModal.tsx
msgid "Stop the DSH Web process that hosts the Borgee connector:"
msgstr "Stop the DSH Web process that hosts the Borgee connector:"

#: src/components/AgentConnectResult.tsx
msgid "Stop the Hermes server"
msgstr "Stop the Hermes server"

#: src/components/AgentConnectResult.tsx
msgid "Stop the running dsh web process with Ctrl+C, then run:"
msgstr "Stop the running dsh web process with Ctrl+C, then run:"

#: src/components/RuntimeCard.tsx
msgid "Stopped"
msgstr "Stopped"

#: src/components/RuntimeCard.tsx
msgid "Stopping…"
msgstr "Stopping…"

#: src/components/AgentLifecycleSection.tsx
msgid "Stops {agentName} receiving messages. It keeps its channels, its history, and its key; one click brings it back."
msgstr "Stops {agentName} receiving messages. It keeps its channels, its history, and its key; one click brings it back."

#: src/components/AgentConnectResult.tsx
msgid "That warning is expected: the connector is configured through the patch layer below"
msgstr "That warning is expected: the connector is configured through the patch layer below"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The active connection does not confirm that the new settings were applied."
msgstr "The active connection does not confirm that the new settings were applied."

#: src/lib/agent-failure-labels.ts
msgid "The API key is invalid. Enter a new one."
msgstr "The API key is invalid. Enter a new one."

#. placeholder {0}: status.exposed_dirs.join(', ')
#: src/components/ComputerDetailView.tsx
msgid "The checkout must live under one of this computer's exposed directories: {0}."
msgstr "The checkout must live under one of this computer's exposed directories: {0}."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The computer could not apply the saved Agent configuration. Check the helper logs on this computer."
msgstr "The computer could not apply the saved Agent configuration. Check the helper logs on this computer."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The computer could not check its Node.js installation. Check that Node.js runs correctly."
msgstr "The computer could not check its Node.js installation. Check that Node.js runs correctly."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The computer could not read its Agent configuration"
msgstr "The computer could not read its Agent configuration"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The computer needs Node.js 22 or later. Update Node.js on this computer."
msgstr "The computer needs Node.js 22 or later. Update Node.js on this computer."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The computer still reports work in progress."
msgstr "The computer still reports work in progress."

#. placeholder {0}: node.machine_name
#: src/components/ComputerDetailView.tsx
msgid "The current connection token for \"{0}\" stops working immediately, so this computer goes offline right away. It stays offline until you re-run the new install command on it."
msgstr "The current connection token for \"{0}\" stops working immediately, so this computer goes offline right away. It stays offline until you re-run the new install command on it."

#: src/components/ComputerDetailView.tsx
msgid "The directory exists, but it is not a Git repository."
msgstr "The directory exists, but it is not a Git repository."

#: src/components/ComputerDetailView.tsx
msgid "The directory is a Git repository, but none of its remotes match {repository}. Run git remote -v in that checkout and retry."
msgstr "The directory is a Git repository, but none of its remotes match {repository}. Run git remote -v in that checkout and retry."

#: src/components/ComputerDetailView.tsx
msgid "The directory is outside this computer's exposed directories. Restart Remote Helper with --dirs to expose it, then retry."
msgstr "The directory is outside this computer's exposed directories. Restart Remote Helper with --dirs to expose it, then retry."

#. placeholder {0}: status.exposed_dirs.join(', ')
#: src/components/ComputerDetailView.tsx
msgid "The directory must be inside one of this computer's exposed directories: {0}. Restart Remote Helper with --dirs if the checkout lives elsewhere."
msgstr "The directory must be inside one of this computer's exposed directories: {0}. Restart Remote Helper with --dirs if the checkout lives elsewhere."

#: src/components/AgentConnectResult.tsx
msgid "The directory this agent works in, not where the connector is installed."
msgstr "The directory this agent works in, not where the connector is installed."

#: src/components/ComputerDetailView.tsx
msgid "The directory was not found on the selected computer. Check the path and retry."
msgstr "The directory was not found on the selected computer. Check the path and retry."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The installed runtime could not be verified. Check the helper logs on this computer."
msgstr "The installed runtime could not be verified. Check the helper logs on this computer."

#. placeholder {0}: agent.display_name
#: src/components/AgentDetailView.tsx
msgid "The key can still be copied, but it will not authenticate while {0} is disabled, and it cannot be rotated until you enable it again."
msgstr "The key can still be copied, but it will not authenticate while {0} is disabled, and it cannot be rotated until you enable it again."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime cannot reach a required service."
msgstr "The runtime cannot reach a required service."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime could not be installed. Check the computer’s internet connection and package access."
msgstr "The runtime could not be installed. Check the computer’s internet connection and package access."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime did not respond in time."
msgstr "The runtime did not respond in time."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime installation is verified. Your saved setup is waiting for the next computer update."
msgstr "The runtime installation is verified. Your saved setup is waiting for the next computer update."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime reports an error. Check its connection settings and local logs."
msgstr "The runtime reports an error. Check its connection settings and local logs."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime reports an unexpected stop."
msgstr "The runtime reports an unexpected stop."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime reports that its API credentials are invalid."
msgstr "The runtime reports that its API credentials are invalid."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The runtime reports that its quota is exhausted."
msgstr "The runtime reports that its quota is exhausted."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The saved configuration has not been acknowledged. Check the helper logs on this computer."
msgstr "The saved configuration has not been acknowledged. Check the helper logs on this computer."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "The selected computer is no longer available"
msgstr "The selected computer is no longer available"

#: src/components/ComputerDetailView.tsx
msgid "This action cannot be undone."
msgstr "This action cannot be undone."

#: src/hooks/useAgentLifecycle.ts
msgid "This Agent has an unrestricted '*' permission grant and cannot be enabled. Clearing its permissions deletes all grants, so first read and save them with GET {permissionsPath}. Clear the entire set with PUT {permissionsPath} and an empty list. Then enable the Agent and restore the saved permissions with PUT {permissionsPath}, excluding every '*' grant at every scope."
msgstr "This Agent has an unrestricted '*' permission grant and cannot be enabled. Clearing its permissions deletes all grants, so first read and save them with GET {permissionsPath}. Clear the entire set with PUT {permissionsPath} and an empty list. Then enable the Agent and restore the saved permissions with PUT {permissionsPath}, excluding every '*' grant at every scope."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "This Agent has no managed computer assigned. It can connect directly using its runtime."
msgstr "This Agent has no managed computer assigned. It can connect directly using its runtime."

#: src/components/ComputerDetailView.tsx
msgid "This checklist confirms what will be removed before this computer is deleted for good."
msgstr "This checklist confirms what will be removed before this computer is deleted for good."

#: src/components/DecommissionAgentModal.tsx
msgid "this computer"
msgstr "this computer"

#: src/components/ComputerDetailView.tsx
msgid "This computer does not have a saved mapping for that repository. Bind the checkout again, then retry."
msgstr "This computer does not have a saved mapping for that repository. Bind the checkout again, then retry."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "This configuration is waiting for the computer’s next setup attempt. The computer has not started this setup request."
msgstr "This configuration is waiting for the computer’s next setup attempt. The computer has not started this setup request."

#: src/components/ComputerDetailView.tsx
msgid "This connected helper does not support repository mappings. Update Remote Helper, then reconnect."
msgstr "This connected helper does not support repository mappings. Update Remote Helper, then reconnect."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "This Helper version does not report setup progress. Update the Borgee helper on your computer to see setup progress."
msgstr "This Helper version does not report setup progress. Update the Borgee helper on your computer to see setup progress."

#: src/lib/openclaw-onboarding.ts
msgid "This lets Borgee read final-turn usage for telemetry. Borgee does not persist message content."
msgstr "This lets Borgee read final-turn usage for telemetry. Borgee does not persist message content."

#: src/components/AgentConnectResult.tsx
msgid "This lets Borgee read the final turn's usage. It does not persist message content."
msgstr "This lets Borgee read the final turn's usage. It does not persist message content."

#: src/components/AgentDetailView.tsx
msgid "This member is a person, or an agent that no longer exists."
msgstr "This member is a person, or an agent that no longer exists."

#: src/components/DecommissionAgentModal.tsx
msgid "This will not delete the computer or affect other hosted agents on it."
msgstr "This will not delete the computer or affect other hosted agents on it."

#: src/components/ComputerDetailView.tsx
msgid "This will not delete this computer or affect any other hosted agents on it."
msgstr "This will not delete this computer or affect any other hosted agents on it."

#. placeholder {0}: node.machine_name
#: src/components/ComputerDetailView.tsx
msgid "This will permanently delete the agent and stop <0>{0}</0> from hosting it on the next remote-helper sync."
msgstr "This will permanently delete the agent and stop <0>{0}</0> from hosting it on the next remote-helper sync."

#: src/components/DecommissionAgentModal.tsx
msgid "This will remove <0>{agentName}</0> from all channels, disconnect it, and permanently delete the agent. This cannot be undone."
msgstr "This will remove <0>{agentName}</0> from all channels, disconnect it, and permanently delete the agent. This cannot be undone."

#: src/components/DecommissionAgentModal.tsx
msgid "This will remove <0>{agentName}</0> from all channels, stop <1>{hostedMachineLabel}</1> from hosting it, and permanently delete the agent. This will not delete the computer or affect any other hosted agents on it."
msgstr "This will remove <0>{agentName}</0> from all channels, stop <1>{hostedMachineLabel}</1> from hosting it, and permanently delete the agent. This will not delete the computer or affect any other hosted agents on it."

#: src/lib/openclaw-onboarding.ts
msgid "To accept this invitation, add Borgee alongside your existing OpenClaw channels."
msgstr "To accept this invitation, add Borgee alongside your existing OpenClaw channels."

#: src/components/AgentDetailView.tsx
#: src/components/AgentDisabledBanner.tsx
#: src/components/AgentSidebar.tsx
msgid "Try again"
msgstr "Try again"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Try refreshing the status again. The Agent stays saved in your workspace."
msgstr "Try refreshing the status again. The Agent stays saved in your workspace."

#: src/components/AgentDetailView.tsx
msgid "turn-full: each turn carries the full Borgee projection inline."
msgstr "turn-full: each turn carries the full Borgee projection inline."

#: src/components/AgentDetailView.tsx
msgid "turn-thin: each turn keeps only a thin Borgee projection layer."
msgstr "turn-thin: each turn keeps only a thin Borgee projection layer."

#: src/lib/agent-state.ts
msgid "Unknown error"
msgstr "Unknown error"

#: src/components/ComputerDetailView.tsx
msgid "Use an absolute path on the selected computer, then retry."
msgstr "Use an absolute path on the selected computer, then retry."

#. placeholder {0}: checked.repository
#. placeholder {1}: checked.path
#: src/components/ComputerDetailView.tsx
msgid "Verified {0} at {1}."
msgstr "Verified {0} at {1}."

#: src/components/ComputerDetailView.tsx
msgid "Verify"
msgstr "Verify"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Verifying"
msgstr "Verifying"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Verifying the agent runtime"
msgstr "Verifying the agent runtime"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "View Agent"
msgstr "View Agent"

#: src/components/FailurePopover.tsx
msgid "View logs"
msgstr "View logs"

#: src/components/DecommissionAgentModal.tsx
msgid "Waiting for {agentName} to go offline..."
msgstr "Waiting for {agentName} to go offline..."

#: src/components/AgentManager.tsx
msgid "Waiting for <0>{createdName}</0> to connect..."
msgstr "Waiting for <0>{createdName}</0> to connect..."

#: src/components/DecommissionAgentModal.tsx
msgid "Waiting for hosted status..."
msgstr "Waiting for hosted status..."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Waiting for setup status"
msgstr "Waiting for setup status"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Waiting for the computer to report this configuration."
msgstr "Waiting for the computer to report this configuration."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Waiting for your computer"
msgstr "Waiting for your computer"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Waiting for your computer to apply the setup"
msgstr "Waiting for your computer to apply the setup"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Waiting to apply"
msgstr "Waiting to apply"

#: src/components/AgentManager.tsx
msgid "What agent do you have?"
msgstr "What agent do you have?"

#: src/components/InviteAgentModal.tsx
msgid "What's your agent's name? They'll join <0>Borgee</0> with default permissions."
msgstr "What's your agent's name? They'll join <0>Borgee</0> with default permissions."

#: src/lib/agent-state.ts
msgid "Working"
msgstr "Working"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "You can close this window. {agentName} will stay in your workspace."
msgstr "You can close this window. {agentName} will stay in your workspace."

#: src/components/PermissionsView.tsx
msgid "You do not have permission to view grants"
msgstr "You do not have permission to view grants"

#: src/components/AgentConfigPanel.tsx
msgid "You have unsaved Agent configuration changes. Leave and discard them?"
msgstr "You have unsaved Agent configuration changes. Leave and discard them?"

#: src/components/AgentManager.tsx
msgid "You no longer have permission to add agents to this Project."
msgstr "You no longer have permission to add agents to this Project."

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "You’re offline"
msgstr "You’re offline"

#: src/components/AgentManager.tsx
msgid "your agent"
msgstr "your agent"

#: src/components/AgentManager.tsx
msgid "Your agent"
msgstr "Your agent"

#: src/components/AgentManager.tsx
msgid "Your Agent"
msgstr "Your Agent"

#: src/components/HostedAgentCreated.tsx
msgid "Your computer"
msgstr "Your computer"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Your computer is offline"
msgstr "Your computer is offline"

#: src/components/ManagedAgentProvisioningStatus.tsx
msgid "Your computer is preparing the saved Agent configuration."
msgstr "Your computer is preparing the saved Agent configuration."

#: src/components/InviteAgentModal.tsx
msgid "Your first channel is #welcome.<0/>Say hello when you get here — someone is waiting.<1/>— {ownerName}"
msgstr "Your first channel is #welcome.<0/>Say hello when you get here — someone is waiting.<1/>— {ownerName}"
